import React from 'react';
import QRCode from 'react-qr-code';
import { qrFontCss } from './machineQrFonts';

export const machineQrValue = (machine) => {
    const message = '¡Hola! Bienvenido al chatbot de Coffee & Vending, por favor haz click en enviar para comenzar ' + machine.uuid;
    return `https://wa.me/+50768823964?text=${encodeURIComponent(message)}`;
};

// Wrap long locations without dropping words or overflowing the printed label.
export const labelLines = (value, width = 25) => {
    const words = String(value || '').trim().toUpperCase().split(/\s+/).filter(Boolean);
    const lines = [];
    for (const word of words) {
        const chunks = word.match(new RegExp(`.{1,${width}}`, 'gu')) || [];
        for (const chunk of chunks) {
            const last = lines.length - 1;
            if (last >= 0 && `${lines[last]} ${chunk}`.length <= width) lines[last] += ` ${chunk}`;
            else lines.push(chunk);
        }
    }
    return lines;
};

export default function MachineQrLabel({ machine }) {
    if (!machine?.uuid) return null;
    const name = machine.machine || '';
    const location = machine.location || '';
    const text = name && location && name.trim().toLowerCase() !== location.trim().toLowerCase()
        ? `${name} · ${location}` : name || location || machine.uuid;
    const lines = labelLines(text);
    const fontSize = Math.min(14, 68 / Math.max(lines.length, 1));
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 426" role="img"
            aria-label={`Etiqueta QR ${machine.uuid}: ${text}`}
            style={{ display: 'block', width: '100%', height: 'auto', background: '#fff' }}>
            <style>{qrFontCss}</style>
            <rect width="600" height="426" fill="#fff" />
            <text x="300" y="53" textAnchor="middle" fill="#9dbb4b" fontFamily="SyncroQrIntro, sans-serif"
                fontSize="36" fontWeight="400" textLength="548" lengthAdjust="spacingAndGlyphs">QUEREMOS ESCUCHARTE</text>
            <path d="M0 328 Q300 289 600 324 V426 H0Z" fill="#196d7c" />
            <g fill="#76573e" fontFamily="SyncroQrPublicSans, sans-serif" textAnchor="middle">
                <text x="129" y="117" fontSize="17" letterSpacing="2">CONSULTAS</text>
                <text x="129" y="142" fontSize="17" letterSpacing="2">RECLAMOS</text>
                <text x="129" y="167" fontSize="17" letterSpacing="2">COMENTARIOS</text>
                <text x="119" y="244" fontSize="48" fontFamily="SyncroQrSugo, sans-serif" fontWeight="400" textLength="196" lengthAdjust="spacingAndGlyphs">ESCANEA</text>
                <text x="196" y="276" fontSize="62" fontFamily="SyncroQrJimmy, cursive" fontStyle="normal">aquí</text>
            </g>
            <path d="M0 267 H135" stroke="#947c65" strokeWidth="2" />
            <g transform="translate(20 349)" fill="#fff">
                <path d="M12 0C5 0 0 5 0 12c0 9 12 23 12 23s12-14 12-23C24 5 19 0 12 0zm0 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10z" />
            </g>
            <text x="151" y="347" fill="#fff" textAnchor="middle"
                fontFamily="SyncroQrPublicSans, sans-serif" fontWeight="400" fontSize={fontSize}>
                {lines.map((line, index) => <tspan key={index} x="151" dy={fontSize}>{line}</tspan>)}
            </text>
            <rect x="261" y="76" width="322" height="322" rx="8" fill="#fff" />
            <path d="M274 127V89H312 M532 89H570V127 M274 347V385H312 M532 385H570V347"
                stroke="#76573e" strokeWidth="5" fill="none" />
            {/* 22 px white margin around a 256 px QR preserves its quiet zone. */}
            <svg x="294" y="109" width="256" height="256" viewBox="0 0 256 256">
                <QRCode value={machineQrValue(machine)} size={256} bgColor="#ffffff" fgColor="#000000" level="M" />
            </svg>
        </svg>
    );
}
